import { Icon } from '@examdojo/core/icon';
import { SimpleCalloutVariant } from '../../../model';

export interface SimpleCalloutColorClasses {
  border: string;
  text: string;
  bg: string;
}

export interface SimpleCalloutVariantConfig {
  label: string;
  icon: Icon;
  color: SimpleCalloutColorClasses;
  pickerColor: string;
}

export interface SimpleCalloutVariantOption {
  label: string;
  value: SimpleCalloutVariant;
  pickerColor: string;
}

export const SIMPLE_CALLOUT_VARIANT_CONFIG: Record<SimpleCalloutVariant, SimpleCalloutVariantConfig> = {
  [SimpleCalloutVariant.ExamTip]: {
    label: 'Exam Tip',
    icon: 'lightbulb',
    color: {
      border: 'border-teal-100 dark:border-teal-900',
      text: 'text-teal-500 dark:text-teal-400',
      bg: 'bg-teal-50 dark:bg-teal-950',
    },
    pickerColor: 'bg-teal-500',
  },
  [SimpleCalloutVariant.Tip]: {
    label: 'Tip',
    icon: 'zap',
    color: {
      border: 'border-orange-100 dark:border-orange-900',
      text: 'text-orange-500 dark:text-orange-400',
      bg: 'bg-orange-50 dark:bg-orange-950',
    },
    pickerColor: 'bg-orange-500',
  },
  [SimpleCalloutVariant.Concept]: {
    label: 'Concept',
    icon: 'info-circle',
    color: {
      border: 'border-neutral-100 dark:border-neutral-900',
      text: 'text-neutral-500 dark:text-neutral-400',
      bg: 'bg-neutral-50 dark:bg-neutral-950',
    },
    pickerColor: 'bg-neutral-500',
  },
  [SimpleCalloutVariant.Warning]: {
    label: 'Warning',
    icon: 'exclamation-triangle',
    color: {
      border: 'border-pink-100 dark:border-pink-900',
      text: 'text-pink-500 dark:text-pink-400',
      bg: 'bg-pink-50 dark:bg-pink-950',
    },
    pickerColor: 'bg-pink-500',
  },
};
